import { render, staticRenderFns } from "./propaganda.vue?vue&type=template&id=0223952b&scoped=true"
import script from "./propaganda.vue?vue&type=script&lang=js"
export * from "./propaganda.vue?vue&type=script&lang=js"
import style0 from "./propaganda.vue?vue&type=style&index=0&id=0223952b&prod&scoped=scoped&lang=scss"
import style1 from "./propaganda.vue?vue&type=style&index=1&id=0223952b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0223952b",
  null
  
)

export default component.exports